import { Button } from '@heroui/react'

const ErrorData = ({ title, description }: { title: string; description: string }) => {
  return (
    <div className="flex flex-col justify-center items-center h-[calc(100vh-180px)] mx-[30px] dark:bg-[#1A1A1A] bg-gray-100 rounded-lg border dark:border-[#2A2A2A] border-gray-200">
      <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mb-4">
        <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
          />
        </svg>
      </div>
      <h3 className="text-lg font-medium dark:text-white text-black mb-2">{title}</h3>
      <p className="text-sm dark:text-[#AFAFAF] text-black text-center max-w-md mb-4">
        {description}
      </p>
      <Button color="primary" size="sm" variant="flat" onPress={() => window.location.reload()}>
        Try Again
      </Button>
    </div>
  )
}

export default ErrorData
